// Copyright 2022 Merit International Inc. All Rights Reserved

import noDataLogo from "./assets/no_data_logo.png";
import orgLogo from "./assets/org_logo.png";

export const Images = {
  noDataLogo,
  orgLogo,
};
